<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal(false)">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Foto de Perfil' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-card>
    <ion-card-content>
      <div class="img-wrapper">
        <img [src]="pessoaFoto | image:' '" />
      </div>
    </ion-card-content>
  </ion-card>

  <ion-grid
    *ngIf="isEnablePicker"
  >
    <ion-row>
      <ion-col>
        <ion-button
          expand="block"
          type="submit"
          class="button-editar"
          (click)="foto()"
        >
          {{'Editar' | translate}}
          <ion-note>
            <i class="fas fa-pen edit"></i>
          </ion-note>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
